export const isNumber = (value: unknown): boolean =>
  typeof value === "number" && Number.isFinite(value);
